import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolDesignHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/")({
    component: ScreenDesignPage,
    staticData: {
        permissions: [PermissionEnum.ToolDesignScreen],
        showInSideMenu: false,
        label: "pages.tool.design.screen.title",
    },
    loader: ({ context: { t } }) => {
        return { breadcrumb: t("pages.tool.design.screen.title") };
    },
});

function ScreenDesignPage() {
    return <TenantPage headerNavigationItems={getToolDesignHeaderItems}>{""}</TenantPage>;
}
